import React, {Component} from 'react'
import propTypes from 'prop-types'
import {AsyncSelectField, SelectField} from 'components/selectField'
import {api} from 'services/api'
import isEqual from "lodash/isEqual"
import {t} from "helpers/language"

require('./referenceSelectField.scss')

const defaultParams = {sortColumn: 'ref', sortDirection: 'asc'}

class ReferenceSelectField extends Component {

  state = {
    references: null,
  }

  componentDidMount = () => {
    const {companyId, contactId} = this.props
    if (contactId || companyId) this.loadReferences(companyId, contactId)
  }

  componentDidUpdate = (prevProps) => {
    if (!isEqual(prevProps, this.props)) {
      const {companyId, contactId} = this.props
      if (contactId !== prevProps.contactId || companyId !== prevProps.companyId) {
        this.loadReferences(companyId, contactId)
      }
    }
  }

  loadReferences = (companyId, contactId) => {
    const {params} = this.props
    if (contactId || companyId) {
      const queryParams = {...params}
      if (contactId) queryParams.contactId = contactId
      if (companyId) queryParams.companyId = companyId
      this.setState({references: []})
      api.references.get(queryParams, this.getFields()).then(response => {
        api.handleResponseNonYield(
            response,
            (key, data) => {
              this.setState({references: data.result || []})
            },
            (key, message) => {
              console.error("Failed to load references", message)
            }
        )
      })
    } else {
      this.setState({references: null})
    }
  }

  getFields = () => {
    const {fields} = this.props
    return {ref: true, desc: true, ...fields}
  }


  focus = () => {
    this.select.focus()
  }

  processResult = (result) => {
    let options = []

    if ((result != null) && (result.length === 1)) {
      const references = result[0]
      options = options.concat(references.orders.map(reference => {
        return {
          type: "order",
          id: reference.id,
          value: 'OR' + reference.id,
          label: reference.ref + ": " + reference.desc,
          order: reference,
        }
      }))
      options = options.concat(references.opportunities.map(reference => {
        return {
          type: "opportunity",
          id: reference.id,
          value: 'OP' + reference.id,
          label: reference.ref + ": " + reference.desc,
          opportunity: reference,
        }
      }))
    }

    return options
  }


  render() {
    const {...otherProps} = this.props
    let {fields} = this.props
    const {params} = this.props
    fields = {ref: true, desc: true, ...fields}

    const {references} = this.state

    return references
        ? <SelectField
            ref={(c) => {
              this.select = c
            }}
            placeholder={t("Find a Reference")}
            options={this.processResult(references)}
            {...otherProps}
        />
        : <AsyncSelectField
            ref={(c) => {
              this.select = c
            }}
            className='referenceSelectField'
            placeholder="Find a Reference"
            params={params}
            fields={fields}
            onLoad={api.references.get}
            onOptions={this.processResult} {...otherProps}
        />
  }
}

ReferenceSelectField.propTypes = {
  companyId: propTypes.number,
  contactId: propTypes.number,
  fields: propTypes.object,
  multi: propTypes.bool,
  joinValues: propTypes.bool,
  params: propTypes.object,
}

ReferenceSelectField.defaultProps = {
  multi: true,
  joinValues: true,
  params: defaultParams,
}

export default ReferenceSelectField
